module.exports = __webpack_public_path__ + "static/media/bolt-orange.f36dbace.svg";